"use client";

import React from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function DesktopNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="227921" className="flex gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group inline-flex h-10 w-max items-center justify-center rounded-md bg-transparent px-4 py-2 text-sm font-default font-medium text-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-8 w-full animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="flex items-center rounded-md px-4 py-3 text-lg font-default font-medium text-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
          {item.label}
        </Link>)}
    </nav>;
}
export default function SiteHeader() {
  return <section id="taxitransfer" className="sticky top-0 z-50 w-full bg-background text-foreground">
      <MenuProvider menu_id="16" className="w-full border-b border-border bg-background/80 shadow-sm backdrop-blur-md transition-all duration-300">
        <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-8">
          <div className="flex h-20 items-center justify-between gap-4">
            {}
            <div className="flex shrink-0 items-center">
              <Link to="/" className="flex items-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
                <img src="/img/travel_logo_main.png" alt="Travel Logo" className="h-8 w-auto object-contain" />
                <span className="sr-only">Travel Főoldal</span>
              </Link>
            </div>

            {}
            <div className="hidden md:flex md:flex-1 md:items-center md:justify-center">
              <DesktopNavConsumer />
            </div>

            {}
            <div className="flex items-center justify-end gap-4 md:shrink-0">
              <Button asChild className="hidden border-0 bg-primary text-primary-foreground font-default font-semibold shadow-md transition-all hover:bg-primary/90 hover:shadow-lg md:inline-flex rounded-full">
                <Link to="#">Kapcsolat</Link>
              </Button>

              {}
              <div className="md:hidden">
                <Sheet>
                  <SheetTrigger asChild>
                    <Button variant="ghost" size="icon" className="text-foreground hover:bg-accent hover:text-accent-foreground rounded-full" aria-label="Menü megnyitása">
                      <Menu className="size-6" />
                    </Button>
                  </SheetTrigger>
                  <SheetContent side="right" className="flex w-[85vw] max-w-[400px] flex-col border-l border-border bg-background p-6">
                    <SheetTitle className="sr-only">Fő Navigációs Menü</SheetTitle>
                    <div className="mb-8 mt-4 flex items-center">
                      <Link to="/" className="flex items-center gap-2">
                        <img src="/img/travel_logo_main.png" alt="Travel Logo" className="h-8 w-auto object-contain" />
                      </Link>
                    </div>
                    
                    <div className="flex-1 overflow-y-auto">
                      <MobileNavConsumer />
                    </div>

                    <div className="mt-auto pt-6">
                      <Button asChild size="lg" className="w-full border-0 bg-primary text-primary-foreground font-default font-semibold shadow-md transition-all hover:bg-primary/90 rounded-full">
                        <Link to="#">Kapcsolat</Link>
                      </Button>
                    </div>
                  </SheetContent>
                </Sheet>
              </div>
            </div>
          </div>
        </div>
      </MenuProvider>
    </section>;
}